<div class="ui-g loyalty-cluster" *ngIf="render.datatable">
  <div class="ui-g-12" >

    <app-kontable #table data-testid="table" title = "{{ 'self_scan.title' | translate }}"
                  [columns] = "['id', 'description', 'division_sales_network_id', 'divisionSalesNetwork',
                  { field: 'date_start', filterTemplate: noFilter, filterType: noFilter, title: 'self_scan.date_start', bodyTemplate: dateTemplateStart },
                  { field: 'date_end', filterTemplate: noFilter, filterType: noFilter, title: 'self_scan.date_end', bodyTemplate: dateTemplateEnd },
                  { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: customFilter, filterTemplate: stateFilter}
                    ]"
                  [titles] = "['common.id', 'self_scan.description', 'self_scan.divsal', 'self_scan.description']"
                  [paginationType]="serverPagination"
                  [showInfoButton]="false"
                  [showGlobalFilter]="false"
                  [showDetailsButton]="false"
                  [showAddButton]="true"
                  [service]="selfscanService"
                  [servicePermissions]="selfScanningPermissions"
                  [(fireNewDataAvailable)]="newDataAvailable"
                  (onAdd)="add()"
                  (onEdit)="edit($event)"
                  (onRecover)="recover($event)"
                  (onRemove)="remove($event)">

                  <ng-template #dateTemplateStart data-testid="dateTemplateStart" let-row>
                    <span>{{ row['date_start'] }}</span>
                  </ng-template>
                  <ng-template #dateTemplateEnd data-testid="dateTemplateEnd" let-row>
                    <span>{{ row['date_end'] }}</span>
                  </ng-template>

                  <ng-template #noFilter data-testid="noFilter" let-col>

                  </ng-template>

                  <ng-template #stateTemplate data-testid="stateTemplate" let-row class="deleted-row">
                    <span *ngIf="row.flg_state == '1'" class="fa fa-trash-o" title="{{'common.deleted' | translate}}"></span>
                    <span *ngIf="row.flg_state == '2'" class="fa fa-ban" title="{{'common.suspended' | translate}}"></span>
                  </ng-template>

                  <ng-template #stateFilter data-testid="stateFilter" let-col>
                    <p-dropdown [options]="listStates" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
                  </ng-template>

    </app-kontable>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-self-scan-rules/loyalty-self-scan-rules.component.html